import React from 'react';
import { MailCheck, MailWarning, MailX, Send, Loader2 } from 'lucide-react';

const summarize = (receipts) => {
  const entries = Object.entries(receipts || {}).filter(([, v]) => v && v.status !== 'skipped');
  if (!entries.length) return { tone: 'none', label: 'No receipt yet', detail: 'No notification has been sent for this order' };
  const failed = entries.filter(([, v]) => v.status === 'failed');
  const detail = entries.map(([who, v]) => `${who === 'owner' ? 'You' : 'Buyer'}: ${v.status}${v.to ? ` → ${v.to}` : ''}${v.error ? ` (${v.error})` : ''}`).join(' · ');
  if (failed.length === entries.length) return { tone: 'failed', label: 'Receipt failed', detail };
  if (failed.length) return { tone: 'partial', label: 'Partly sent', detail };
  return { tone: 'sent', label: 'Receipt sent', detail };
};

const TONES = {
  sent: { cls: 'bg-emerald-100 text-emerald-800', Icon: MailCheck },
  partial: { cls: 'bg-[#f4b400]/20 text-[#7a5a00]', Icon: MailWarning },
  failed: { cls: 'bg-[#c8102e]/10 text-[#c8102e]', Icon: MailX },
  none: { cls: 'bg-[#0a1f44]/5 text-[#0a1f44]/60', Icon: MailWarning },
};

export const ReceiptStatus = ({ order, busy, onResend, compact = false }) => {
  if (order.status !== 'paid') return null;
  const s = summarize(order.receipts);
  const { cls, Icon } = TONES[s.tone];
  const key = order.invoiceNumber;
  return (
    <div className={`flex items-center gap-1 ${compact ? '' : 'justify-center'}`}>
      <span title={s.detail} data-testid={`order-receipt-badge-${key}`} data-tone={s.tone} className={`inline-flex items-center gap-1 font-heading uppercase tracking-widest text-[9px] px-2 py-1 ${cls}`}>
        <Icon className="w-3 h-3" /> {s.label}
      </span>
      <button
        type="button"
        onClick={() => onResend(order.id)}
        disabled={busy}
        data-testid={`order-resend-receipt-${key}`}
        title="Resend receipt to you and the buyer"
        aria-label={`Resend receipt for ${key}`}
        className={`${compact ? 'min-h-9 px-2' : 'p-1.5'} inline-flex items-center gap-1 text-[#0a1f44]/60 hover:text-white hover:bg-[#0a1f44] transition-colors disabled:opacity-50 font-heading uppercase text-[9px]`}
      >
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}{compact && ' Resend'}
      </button>
    </div>
  );
};
